import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import vaultRequestsPlugin from '@internal/backstage-plugin-vault-requests';
import { navModule } from './modules/nav';
import { signInModule } from './modules/signIn';
import { oidcAuthModule } from './modules/oidcAuth';

export default createApp({
  features: [
    catalogPlugin,
    scaffolderPlugin,
    notificationsPlugin,
    signalsPlugin,
    vaultRequestsPlugin,
    navModule,
    signInModule,
    oidcAuthModule,
  ],
});
